import { render } from "./HabilidadesPlay.vue?vue&type=template&id=cd349e5c&scoped=true"
import script from "./HabilidadesPlay.vue?vue&type=script&lang=js"
export * from "./HabilidadesPlay.vue?vue&type=script&lang=js"

import "./HabilidadesPlay.vue?vue&type=style&index=0&id=cd349e5c&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd349e5c"]])

export default __exports__